const fiveSeconds = '5000'
const handleRowClick = (event, member, selected, setSelected) => {
  const membersCopy = selected.filter((e) => e.email !== member.email)
  if (member.isSelected) {
    member.isSelected = !member.isSelected
    if (!member.isSelected) {
      setSelected(membersCopy)
    }
  } else {
    member.isSelected = true
    setSelected([...selected, member])
  }
}

const getEmails = (selected) => {
  return selected.map((member) => member.email)
}

const updateEmails = (prepublishMembers) => {
  return prepublishMembers.filter((member) => member.isSelected !== true)
}

const errorMessage = (setEmailState, emailState) => {
  setEmailState({ ...emailState, emailError: true })
  setTimeout(() => {
    setEmailState({ ...emailState, emailError: false })
  }, fiveSeconds)
}

const ascendingSorting = (prepublishMembers) => {
  prepublishMembers.sort((a, b) => {
    if (a.email.toLowerCase() < b.email.toLowerCase()) return -1
    if (a.email.toLowerCase() > b.email.toLowerCase()) return 1
    return 0
  })
}
const descendingSorting = (prepublishMembers) => {
  prepublishMembers.sort((a, b) => {
    if (a.email.toLowerCase() < b.email.toLowerCase()) return 1
    if (a.email.toLowerCase() > b.email.toLowerCase()) return -1
    return 0
  })
}
const onSubmitNewMember = (
  fireDepartmentId,
  identifier,
  email,
  createUser,
  setPrepublishMembers,
  prepublishMembers,
  errorSnackBarActions
) => {
  const newMember = { fireDepartmentId, identifier, email }
  let found = false
  let emailFound = ''
  prepublishMembers.forEach((e) => {
    if (e.email.toLowerCase() === email.toLocaleLowerCase()) {
      found = true
      emailFound = e.email
    }
  })
  if (found) {
    errorSnackBarActions.setOpen(true, `${emailFound} is already is use!`)
    setTimeout(() => {
      errorSnackBarActions.setOpen(false)
    }, fiveSeconds)
  } else {
    createUser(fireDepartmentId, identifier, email).then(() =>
      setPrepublishMembers([...prepublishMembers, newMember])
    )
  }
}

const onDeleteMember = (
  identifier,
  emails,
  newEmails,
  deleteUser,
  setSelected,
  setPrepublishMembers,
  emailState,
  setEmailState
) => {
  deleteUser(identifier, emails).then((res) => {
    setSelected([])
    setPrepublishMembers(newEmails)
    setEmailState({
      ...emailState,
      checkedBox: false,
      openDialog: false,
      allSelectedCounter: 0
    })
  })
}

const onSelectAllClick = (
  allSelectedCounter,
  prepublishMembers,
  setPrepublishMembers,
  setSelected,
  setEmailState,
  emailState
) => {
  const counter = allSelectedCounter % 2 == 0
  let isSelectedState = counter ? true : false
  let newMembers = []
  prepublishMembers.forEach((member) => {
    if (member.isSelected) {
      member.isSelected = isSelectedState
    }
    member.isSelected = isSelectedState
    newMembers.push(member)
    setPrepublishMembers(newMembers)
    setSelected(counter ? newMembers : [])
  })
  setEmailState((prevState) => ({
    ...emailState,
    allSelectedCounter: prevState.allSelectedCounter + 1,
    checkedBox: !prevState.checkedBox
  }))
}

const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
export const PrepublishMembersFunctions = {
  handleRowClick,
  getEmails,
  updateEmails,
  emailRegex,
  onDeleteMember,
  onSubmitNewMember,
  errorMessage,
  onSelectAllClick,
  ascendingSorting,
  descendingSorting
}
